/* Moonwraps - the country and currency selector.
 *
 * The form itself is Shopify's localization form and each option is a real
 * submit button, so choosing a country works without any of this. This file
 * only adds the open and close behaviour and the keyboard handling, and it
 * works by delegation so the copy inside the mobile drawer template behaves
 * the same once the theme clones it into the page.
 */
(function () {
  'use strict';

  function menuOf(root) { return root.querySelector('[data-mw-cs-menu]'); }
  function btnOf(root) { return root.querySelector('[data-mw-cs-btn]'); }
  function optsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-mw-cs-opt]'));
  }

  function close(root, refocus) {
    var btn = btnOf(root), menu = menuOf(root);
    if (!btn || !menu || menu.hidden) return;
    menu.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (refocus) btn.focus();
  }

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mw-cs]'), function (r) {
      if (r !== except) close(r, false);
    });
  }

  function open(root) {
    var btn = btnOf(root), menu = menuOf(root);
    if (!btn || !menu) return;
    closeAll(root);
    menu.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    var opts = optsOf(root);
    var current = opts.filter(function (o) {
      return o.getAttribute('aria-current') === 'true';
    })[0];
    if (current || opts[0]) (current || opts[0]).focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mw-cs-btn]');
    if (btn) {
      var root = btn.closest('[data-mw-cs]');
      var menu = menuOf(root);
      if (menu.hidden) { open(root); } else { close(root, true); }
      return;
    }
    if (!(e.target.closest && e.target.closest('[data-mw-cs]'))) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    var root = e.target.closest && e.target.closest('[data-mw-cs]');
    if (!root) return;

    var opts = optsOf(root);
    var menu = menuOf(root);
    var onBtn = !!(e.target.closest('[data-mw-cs-btn]'));

    if (e.key === 'Escape') {
      if (!menu.hidden) { e.preventDefault(); close(root, true); }
      return;
    }

    if (onBtn && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
      if (menu.hidden) open(root);
      return;
    }

    if (menu.hidden) return;

    var i = opts.indexOf(e.target.closest('[data-mw-cs-opt]'));
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      opts[(i + 1 + opts.length) % opts.length].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      opts[(i - 1 + opts.length) % opts.length].focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      opts[0].focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      opts[opts.length - 1].focus();
    } else if (e.key === 'Tab') {
      close(root, false);
    }
  });
})();
